export const RichText = ({ text = "" }) => {
  const blocks = text.split(/\n\s*\n/);
  const out = [];
  blocks.forEach((block, bi) => {
    let list = [];
    const flush = (k) => {
      if (list.length) out.push(<ul key={`ul-${k}`}>{list.map((li, i) => <li key={i}>{li}</li>)}</ul>);
      list = [];
    };
    block.split("\n").forEach((line, li) => {
      const t = line.trim();
      if (!t) return;
      if (t.startsWith("## ")) {
        flush(`${bi}-${li}`);
        out.push(<h2 key={`h-${bi}-${li}`}>{t.slice(3)}</h2>);
      } else if (t.startsWith("- ")) {
        list.push(t.slice(2));
      } else {
        flush(`${bi}-${li}`);
        out.push(<p key={`p-${bi}-${li}`}>{t}</p>);
      }
    });
    flush(`${bi}-end`);
  });
  return <div className="prose-calm">{out}</div>;
};
